const features = [
  {
    title: '悬疑剧场',
    subtitle: '烧脑推理 · 层层反转',
    desc: '精选国产悬疑佳作，从密室到法庭，从都市到乡村，每一部都让人欲罢不能。暗夜追凶、迷雾追踪、真相只有一个。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20movie%20theater%20dark%20moody%20lighting%20with%20film%20noir%20style%2C%20detective%20elements%2C%20red%20and%20gold%20accents%2C%20mysterious%20cinematic%20composition%2C%20shadowy%20figures%2C%20dramatic%20contrast&width=1000&height=560&seq=carousel-01&orientation=landscape',
  },
  {
    title: '动作猛片',
    subtitle: '热血沸腾 · 全程高能',
    desc: '最硬核的国产动作片合集，真枪实弹的打斗场面，震撼的视觉冲击力，让你肾上腺素飙升。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20epic%20battle%20scene%20with%20explosions%20and%20heroic%20figures%2C%20dramatic%20warm%20lighting%20red%20and%20gold%20tones%2C%20cinematic%20wide%20shot%2C%20intense%20combat%20atmosphere&width=1000&height=560&seq=carousel-02&orientation=landscape',
  },
  {
    title: '文艺佳作',
    subtitle: '细腻动人 · 口碑之选',
    desc: '那些年打动人心的国产文艺片，用镜头语言讲述平凡而深刻的故事，每一帧都是艺术品。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20artistic%20drama%20film%20scene%20soft%20natural%20light%20through%20window%2C%20poetic%20composition%2C%20warm%20gentle%20colors%2C%20person%20reading%20by%20window%2C%20nostalgic%20atmosphere%2C%20golden%20hour%20lighting&width=1000&height=560&seq=carousel-03&orientation=landscape',
  },
  {
    title: '科幻纪元',
    subtitle: '脑洞大开 · 视觉盛宴',
    desc: '国产科幻电影的崛起之路，从星际穿越到AI觉醒，中国电影人用想象力描绘未来世界。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20science%20fiction%20movie%20futuristic%20cityscape%20with%20neon%20lights%2C%20advanced%20technology%2C%20warm%20gold%20and%20crimson%20color%20palette%2C%20epic%20scale%20cinematic%20composition%2C%20flying%20vehicles%20in%20sky&width=1000&height=560&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按类型精选的国产电影专题合集，帮你快速找到喜欢的类型
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {features.map((item) => (
            <article
              key={item.title}
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-background-950/10 to-transparent"></div>
              </div>
              <div className="p-5">
                <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full">
                  {item.subtitle}
                </span>
                <h3 className="mt-3 text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}